import _ from 'lodash'

export const FETCH_ANSWERS = 'FETCH_ANSWERS'
export const FETCH_ANSWERS_SUCCESS = 'FETCH_ANSWERS_SUCCESS'

export const DELETE_ANSWER = 'DELETE_ANSWER'

export const fetchAnswers = (payload) => ({
  type: FETCH_ANSWERS,
  payload: _.pick(payload, ['offset', 'limit', 'search', 'sort_by', 'order_by', 'showToast'])
})

export const fetchAnswersSuccess = (payload) => ({
  type: FETCH_ANSWERS_SUCCESS,
  payload: _.pick(payload, ['answers', 'totalCount'])
})

export const deleteAnswer = (payload) => ({
  type: DELETE_ANSWER,
  payload: _.pick(payload, ['answerId'])
})
